@if (form) {
  <div>
    @switch (item().type) {
      @case ('input') {
        <ng-container *ngTemplateOutlet="input"></ng-container>
      }
      @case ('textarea') {
        <ng-container *ngTemplateOutlet="textarea"></ng-container>
      }
      @case ('number') {
        <ng-container *ngTemplateOutlet="number"></ng-container>
      }
      @case ('tel') {
        <ng-container *ngTemplateOutlet="tel"></ng-container>
      }
      @case ('select') {
        <ng-container *ngTemplateOutlet="select"></ng-container>
      }
      @case ('name') {
        <ng-container *ngTemplateOutlet="name"></ng-container>
      }
      @default {
        {{ item().type }}です（未対応）
      }
    }
  </div>
  @if (touched() && form.invalid) {
    <mat-error>この項目は必須です</mat-error>
  }
}

<ng-template #input>
  <h3 class="co-form__name">{{ item().name }} <span>必須</span></h3>
  <p>
    <input class="co-form__text" type="text"  [formControl]="form.controls[item().key]" [name]="item().key"  required>
  </p>
</ng-template>

<ng-template #textarea>
  <h3 class="co-form__name">{{ item().name }} <span>必須</span></h3>
  <p>
    <textarea class="co-form__textarea" [formControl]="form.controls[item().key]" [name]="item().key" required></textarea>
  </p>
</ng-template>

<ng-template #number>
  <h3 class="co-form__name">{{ item().name }} <span>必須</span></h3>
  <p>
    <input  class="co-form__text" type="number" [formControl]="form.controls[item().key]" [name]="item().key" required>
  </p>
</ng-template>

<ng-template #tel>
  <h3 class="co-form__name">{{ item().name }} <span>必須</span></h3>
  <p>
    <input class="co-form__text" type="tel" matInput [formControl]="form.controls[item().key]" [name]="item().key" required>
  </p>
</ng-template>

<ng-template #select>
  <h3 class="co-form__name">{{ item().name }} <span>必須</span></h3>
  <div class="co-form__selectWrapper">
    <select class="co-form__select" [formControl]="form.controls[item().key]" required>
      <option>-選択してください-</option>
      @for (option of item().options; track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </div>
</ng-template>

<ng-template #name>
  <h3 class="co-form__name">{{ item().name }}<span>必須</span></h3>
  <div class="flex">
    <input class="co-form__text" type="text" [formControl]="form.controls['last'+upperKey]" [name]="'last'+upperKey" required>
    <input class="co-form__text" type="text" matInput [formControl]="form.controls['first'+upperKey]" [name]="'first'+upperKey" [required]="isRequired()">
  </div>
</ng-template>
